import './Admin-home.css';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSackDollar, faUserAstronaut } from '@fortawesome/free-solid-svg-icons';
import { faDashcube, faStackpath } from '@fortawesome/free-brands-svg-icons';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const AdminHome = () => {
  const [reservationCount, setReservationCount] = useState(0);
  const [userCount, setUserCount] = useState(0);
  const [sales, setSales] = useState(0);
  const [miscellaneous, setMiscellaneous] = useState(0);

  const fetchReservations = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/bookings/get-reservations`);
      const data = await response.json();
  

      // Filter reservations with hasPaid set to true
      const paidReservations = data.filter((reservation) => reservation.hasPaid);

      // Calculate the total dues paid
      const amtPaid = paidReservations.reduce(
        (total, reservation) => total + reservation.priceToBePaid,
        0
      );

      // Calculate the values
      let dataPercentage = 0;
      let hostingPercentage = 0;
      let devPercentage = 0;
      paidReservations.forEach((reservation) => {
        dataPercentage += 1;
        hostingPercentage += 2;
        devPercentage+=2;
      });

      const sales = amtPaid;
      const miscellaneous = sales - (dataPercentage + hostingPercentage+ devPercentage);

      setReservationCount(paidReservations.length);
      setSales(sales);
      setMiscellaneous(miscellaneous);
    } catch (error) {
      console.error('Error fetching reservations:', error);
    }
  };

  const fetchUserCount = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/newuser/accounts`);
      const data = await response.json();
      setUserCount(data.accounts.length);
    } catch (error) {
      console.error('Error fetching user count:', error);
    }
  };



  useEffect(() => {
    fetchUserCount()
    fetchReservations ()
  }, []);


  return (
    <div className="Admin-home-container">
      <div className="Admin-home-wrapper">
        <div className="home-card">
          <div className='box-flow purple'><FontAwesomeIcon className='big' icon={faUserAstronaut}></FontAwesomeIcon></div>
          Number of User Accounts: <span className="tomato">{userCount}</span>
        </div>
        <div className="home-card">
          <div className='box-flow green-i'><FontAwesomeIcon className='big' icon={faSackDollar}></FontAwesomeIcon></div>
         Amount: <span className="tomato">{reservationCount}</span>
        </div>
        <div className="home-card">
          <div className='box-flow indigo'><FontAwesomeIcon className='big' icon={faDashcube}></FontAwesomeIcon></div>
          Number of request: <span className="tomato"></span>
        </div>
      </div>
      <div className="dash-flex">
        <div className="home-card flex-3">
          <div className='box-flow teal'><FontAwesomeIcon className='big' icon={faStackpath}></FontAwesomeIcon></div>
          Statistics 
          <div className="dash-block">Sales: GH₵<span className="tomato">{sales}.00</span></div>
          <div className="dash-block">Miscellaneous: GH₵ <span className="tomato">{miscellaneous}.00</span></div>
        </div>
        
      </div>
    </div>
  );
};

export default AdminHome;
